import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Store } from 'src/app/core/store/store';
import { Course } from 'src/app/shared/models/course.model';
import { User } from 'src/app/shared/models/user.model';
import { EventsService } from 'src/app/shared/services/events.service';
import { UtilityService } from 'src/app/shared/utils/utility.service';
import { PlayerUtilityService } from '../../../services/player-utility.service';

@Component({
  selector: 'app-resources',
  templateUrl: './resources.component.html',
  styleUrls: ['./resources.component.css']
})
export class ResourcesComponent implements OnInit {
  @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>(false);
  @Output() sideBarClicked: EventEmitter<boolean> = new EventEmitter<boolean>(false);
  subscription: any;
  modules: any[];
  @Input() courseId: any;
  @Input() courseData: Course;

  @Input() isLocked: boolean = false;
  user: User;
  activationData: any;
  course: Course;

  constructor(private store: Store, private playerUtilityService: PlayerUtilityService, private utilitySerice: UtilityService, private eventsService: EventsService) { }


  ngOnInit() {
    if (this.courseId) {
      this.subscription = this.store.select<Course>(`course`).subscribe(course => {
        if (course) {
          this.course = course;
          this.modules = [];
          for (let cont of course.contents) {
            let i = this.modules.findIndex(g => g.moduleNumber == cont.moduleNumber);
            (i >= 0 && this.modules[i].contents.push(cont.contentInfo)) || this.modules.push({ moduleName: cont.moduleName, moduleNumber: cont.moduleNumber, contents: [cont.contentInfo] })
          }
          this.modules = this.modules.sort((a, b) => a.moduleNumber - b.moduleNumber);
          this.subscription && this.subscription.unsubscribe()
          this.subscription = null;
        }
      });
    }

    this.store.select<User>('user').subscribe(user => {
      if (user) {
        this.user = user;
      }
    });
    this.store.select('activation').subscribe((data: any) => {
      if(data && data[0]) {
        this.activationData = data[0];
      }
    })

  }

  onClose() {
    this.close.emit(true);
  }

  isResourcesExists(module) {
    if (module.contents.length)
      return module.contents.some(el => el.cards && el.cards.length > 0);
    return false;
  }
  download(content?) {
    this.utilitySerice.updateEngagement('EntusiasticAdoption', 'DownloadingResource', 1).subscribe();
    try {
      if(this.user && this.activationData && this.course && content && content.title){
        let eventData = { 'user': this.user, 'course': this.course, 'activationData': this.activationData, 'nugget': content.title }
        this.eventsService.downloadResourceEvent(eventData);
      }
    } catch (err) { console.log(err); }
  }

}
